<script lang="ts">
  import { Button, Col, Form, FormGroup, Input, Label } from "sveltestrap";
  import { ExpirationDate, Submit, href } from "../../../../utils/Constant/Constant";

</script>
<Form class="theme-form e-commerce-form row">
  <Col xs="6" class="p-r-0">
    <FormGroup>
      <Input type="text" placeholder="Full name here" />
    </FormGroup>
  </Col>
  <Col xs="6">
    <FormGroup>
      <Input type="text" placeholder="Card number" />
    </FormGroup>
  </Col>
  <Col xs="6" class="p-r-0">
    <FormGroup>
      <Input type="text" placeholder="CVV number" />
    </FormGroup>
  </Col>
  <Col xs="6">
    <FormGroup>
      <Input type="text" placeholder="CVC" />
    </FormGroup>
  </Col>
  <Col xs="12">
    <Label class="col-form-label p-b-20">{ExpirationDate}</Label>
  </Col>
  <Col xs="6" class="p-r-0">
    <FormGroup>
      <Input type="select" name="select" value="Select Month" >
        <option>{'Select Month'}</option>
        <option>{'Jan'}</option>
        <option>{'Fab'}</option>
        <option>{'March'}</option>
        <option>{'April'}</option>
      </Input>
    </FormGroup>
  </Col>
  <Col xs="6">
    <FormGroup>
      <Input type="select" name="select" value="Select Year">
        <option>{'Select Year'}</option>
        <option>{'2015'}</option>
        <option>{'2016'}</option>
        <option>{'2017'}</option>
        <option>{'2018'}</option>
        <option>{'2019'}</option>
      </Input>
    </FormGroup>
  </Col>
  <Col xs="12">
    <Button color="primary" class="btn-block" href={href}>{Submit}</Button>
  </Col>
</Form>